import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { API } from "../../../config";

export const useProductListing = () => {
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [openedCategories, setOpenedCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState({
    loading: false,
    initialLoading: true,
  });
  const [filters, setFilters] = useState({
    search: "",
    category: [],
    subcategory: [],
    priceRange: [0, 100000],
    sortBy: "",
    sortOrder: "",
    moreFiltersHidden: false,
  });
  const [debouncedSearch, setDebouncedSearch] = useState(filters.search);

  const [categories, setCategories] = useState([]);

  const getCategoryProducts = useCallback(
    (categoryId) => {
      return products?.filter((item) => item.categoryId === categoryId);
    },
    [products]
  );

  const buildAndPrint = useCallback((categoryWise, customPrices) => {
    let contentHtml = "";

    categoryWise.forEach((block, idx) => {
      const { category, products: prods } = block;

      contentHtml += `
        <div class="category-section" style="${
          idx > 0 ? "page-break-before: always;" : ""
        }">
          <div class="category-header" style="margin-top: 20px;">
            ${category.name}
          </div>
      `;

      prods.forEach((product) => {
        const details = (product.item_Details || [])
          .map((item, i) => `<div class="detail-item">${i + 1}. ${item}</div>`)
          .join("");

        const price =
          customPrices && customPrices[product._id] !== undefined
            ? Number(customPrices[product._id])
            : Number(product.price?.[0]?.cost ?? 0);

        contentHtml += `
          <div class="product-card">
            <div class="card-left">
              <img src="${product.image?.[0] || ""}" alt="${
          product.name || ""
        }" class="product-image" />
              <div class="card-text">
                <div class="product-name">${product.name || ""}</div>
                <div class="product-brand">${product.brandName || ""}</div>
                <div class="section-label">Description</div>
                <div class="description-text">${product.description || ""}</div>
                ${
                  details
                    ? `
                  <div class="section-label">Item Details</div>
                  <div class="details-list">${details}</div>
                `
                    : ""
                }
              </div>
            </div>
            <div class="product-price">₹${price.toFixed(2)}</div>
          </div>
        `;
      });

      contentHtml += `</div>`;
    });

    contentHtml += `
      <div class="notes-section">
        <div class="note-item">• Above mentioned prices are exclusive of GST</div>
        <div class="note-item">• Pricing may vary based on customisation type/branding requirement</div>
      </div>
    `;

    const printWindow = window.open("", "_blank", "width=900,height=700");

    if (!printWindow) {
      alert("Please allow popups to export PDF.");
      return;
    }

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Products Export</title>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap');

          * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          html {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          body {
            font-family: 'Nunito', Arial, sans-serif;
            padding: 40px;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
            background-color: #faf7f1 !important;
            box-shadow: inset 0 0 0 9999px #faf7f1;
          }

          .category-section {
            margin-bottom: 30px;
          }

          .category-header {
            font-size: 20px;
            font-weight: 600;
            color: #0f143a;
            margin-bottom: 20px;
          }

          .product-card {
            border-radius: 20px;
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            gap: 22px;
            padding: 35px;
            margin-bottom: 15px;
            page-break-inside: avoid;
            background-color: #fff !important;
            box-shadow: inset 0 0 0 9999px #fff;
            border: 1px solid #e0e0e0;
          }

          .card-left {
            display: flex;
            flex-direction: row;
            gap: 22px;
            flex: 1;
          }

          .product-image {
            width: 180px;
            height: 150px;
            object-fit: contain;
            border-radius: 10px;
            flex-shrink: 0;
          }

          .card-text {
            display: flex;
            flex-direction: column;
            flex: 1;
          }

          .product-name {
            font-size: 18px;
            font-weight: 700;
            color: #0f143a;
            margin-bottom: 4px;
          }

          .product-brand {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            margin-bottom: 10px;
          }

          .section-label {
            font-size: 12px;
            font-weight: 700;
            color: #000;
            padding-top: 10px;
          }

          .description-text {
            font-size: 12px;
            font-weight: 400;
            color: #000;
          }

          .details-list {
            font-size: 12px;
            color: #000;
          }

          .detail-item {
            font-size: 12px;
            color: #000;
          }

          .notes-section {
            margin-top: 40px;
            font-size: 11px;
            color: #333;
          }

          .note-item {
            margin-left: 12px;
            margin-bottom: 2px;
          }

          .product-price {
            font-weight: 700;
            font-size: 24px;
            color: #0f143a;
            white-space: nowrap;
            flex-shrink: 0;
          }

          @media print {
            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
              color-adjust: exact !important;
            }

            html, body {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
              color-adjust: exact !important;
            }

            body {
              background-color: #faf7f1 !important;
              box-shadow: inset 0 0 0 9999px #faf7f1 !important;
            }

            .product-card {
              background-color: #fff !important;
              box-shadow: inset 0 0 0 9999px #fff !important;
              page-break-inside: avoid;
              border: 1px solid #e0e0e0 !important;
            }

            .category-section {
              page-break-before: auto;
            }

            .category-section:not(:first-child) {
              page-break-before: always;
            }
          }
        </style>
      </head>
      <body>
        ${contentHtml}
        <script>
          const images = document.querySelectorAll('img');
          let loadedCount = 0;
          const totalImages = images.length;

          function triggerPrint() {
            setTimeout(function() {
              window.print();
              window.onafterprint = function() { window.close(); };
            }, 500);
          }

          if (totalImages === 0) {
            triggerPrint();
          } else {
            images.forEach(img => {
              if (img.complete) {
                loadedCount++;
                if (loadedCount === totalImages) {
                  triggerPrint();
                }
              } else {
                img.onload = img.onerror = function() {
                  loadedCount++;
                  if (loadedCount === totalImages) {
                    triggerPrint();
                  }
                };
              }
            });
          }
        </script>
      </body>
      </html>
    `);

    printWindow.document.close();
  }, []);

  const getSelectedCategoryWise = useCallback(() => {
    return categories
      .map((category) => {
        const categoryProducts = getCategoryProducts(category._id) || [];
        const selectedInCategory = categoryProducts.filter((p) =>
          selectedProducts.includes(p._id)
        );
        return { category, products: selectedInCategory };
      })
      .filter((c) => c.products.length > 0);
  }, [selectedProducts, categories, getCategoryProducts]);

  const handleContinue = useCallback(() => {
    if (!selectedProducts.length) {
      alert("Please select at least one product to export.");
      return;
    }
    const categoryWise = getSelectedCategoryWise();
    if (!categoryWise.length) {
      alert("No products found for export.");
      return;
    }
    return categoryWise;
  }, [selectedProducts, getSelectedCategoryWise]);

  const handleExport = useCallback((customPrices) => {
    const categoryWise = getSelectedCategoryWise();
    if (!categoryWise.length) return;
    buildAndPrint(categoryWise, customPrices);
  }, [getSelectedCategoryWise, buildAndPrint]);

  const getCategories = async () => {
    try {
      const response = await axios.get(`${API}/Admin/category/get`);
      const all = response?.data?.allcategory || [];
      const firstWithProducts =
        all.find(
          (category) => (getCategoryProducts(category._id) || []).length > 0
        ) || all[0];

      if (firstWithProducts) {
        setOpenedCategories([String(firstWithProducts._id)]);
      }
      setCategories(all);
    } catch (e) {
      console.error("Failed to fetch categories", e);
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(filters.search);
    }, 1000);
    return () => clearTimeout(timer);
  }, [filters.search]);

  const getProducts = useCallback(async () => {
    setLoading((prev) => ({
      loading: true,
      initialLoading: prev.initialLoading,
    }));
    const response = await axios.get(`${API}/Admin/addProduct`, {
      params: {
        search: debouncedSearch,
        categories: filters?.category?.join(","),
        subCategories: filters?.subcategory?.join(","),
        minPrice: filters?.priceRange[0],
        maxPrice: filters?.priceRange[1],
        sortBy: filters?.sortBy.trim() ?? undefined,
        sortOrder: filters?.sortOrder.trim() ?? undefined,
      },
    });

    const fetchedProducts = response.data.products || [];
    setProducts(fetchedProducts);

    if (fetchedProducts.length > 0) {
      const productCategoryIds = [
        ...new Set(fetchedProducts.map((p) => String(p.categoryId))),
      ];

      const categoriesWithProducts = categories
        .filter((cat) => productCategoryIds.includes(String(cat._id)))
        .sort((a, b) => (a.order ?? Infinity) - (b.order ?? Infinity));

      if (categoriesWithProducts.length > 0) {
        setOpenedCategories([String(categoriesWithProducts[0]._id)]);
      }
    }

    setLoading((prev) => ({
      loading: false,
      initialLoading: false,
    }));
  }, [
    debouncedSearch,
    filters.category,
    filters.subcategory,
    filters.priceRange,
    filters.sortBy,
    filters.sortOrder,
    categories,
  ]);

  const handleFiltersChange = (key, value) => {
    setFilters((p) => ({ ...p, [key]: value }));
  };
  useEffect(() => {
    getProducts();
  }, [
    debouncedSearch,
    filters.category,
    filters.subcategory,
    filters.priceRange,
    filters.sortBy,
    filters.sortOrder,
  ]);

  const handleSortSelect = (sortBy, sortOrder) => {
    handleFiltersChange("sortBy", sortBy);
    handleFiltersChange("sortOrder", sortOrder);
  };

  const selectedSubCategories =
    categories
      .filter((c) => filters.category.map(String).includes(String(c._id)))
      .flatMap((c) => c.subCategories || []) || [];

  return {
    products,
    loading,
    filters,
    handleFiltersChange,
    handleSortSelect,
    selectedSubCategories,
    categories,
    selectedProducts,
    setSelectedProducts,
    openedCategories,
    setOpenedCategories,
    getCategoryProducts,
    handleContinue,
    handleExport,
  };
};
